import { Ads } from './types'
import config from './_config'
import { useQuery } from '../../internal'
import { API } from '../../internal/types'
import create from 'zustand'
import { State } from '../../store/types'
import store from '../../store'

const useGetBigBanner = (options?: API.QueryOptions) => {
  const useStore = create<State>(store)

  const { networkId } = useStore()

  const query = useQuery(
    undefined,

    {
      ...options,
      staleTime: Infinity // Banners should be "fresh" while the app is running to avoid refetches
    },
    { sponsored: true }
  )

  const response = query<Ads.Banner[]>({
    cacheKey: config.cacheKeys?.big(),
    endpoint: config.endpoints?.big(networkId)
  })

  return response
}

export default useGetBigBanner
